import { TDescriptionValue } from 'shared/types/typographyComponents';

export const LIST: TDescriptionValue[][] = [
  [{ value: 'Прозрачность для гостей — они платят только за проживание, без скрытых комиссий' }],
  [{ value: 'Защиту интересов обеих сторон — Циан помогает урегулировать спорные ситуации' }],
  [{ value: 'Встроенную страховку имущества для арендодателей' }],
];

export const DESCRIPTION = [
  [
    {
      value: 'С июня 2025 года сервис перешёл на модель ',
    },
    { value: 'Online Travel Agency (OTA) или онлайн-бронирование.', isBold: true },
    {
      value: ' Платформа выступает посредником между гостем и хостом, а монетизация строится на комиссии за бронь. ',
    },
  ],
];
